export enum MaintenanceStatus {
  Active = 'active',
  Inactive = 'inactive',
  Unknown = 'unknown',
}
